import $ from 'jquery';
import jQueryPlaceholer from 'jquery-placeholder';
import _ from 'underscore';
import Backbone from 'backbone';
import BackboneValidation from 'backbone-validation';
import Global from 'models/Global';
import Auth from 'models/Auth';
import FormViewMixin from 'views/FormViewMixin';
import EditProfileImageView from 'views/EditProfileImageView';
import LinkedInProfileView from 'views/LinkedInProfileView';
import signUpTemplate from 'hbars!templates/signUp';
import Ladda from 'ladda';

var EditProfileView = Backbone.View.extend({
    events: {
        'change input': 'formChanged',
        'change select': 'formChanged',
        'change textarea': 'formChanged',
        'click .edit-profile-save-button-ladda': 'saveClicked',
        'click .edit-profile-sync-confirm': 'syncBasicInformationFromLinkedin'
    },

    hasChanged: false,

    saveButton: Ladda.create(document.querySelector('.edit-profile-save-button-top')),

    saveButtonBottom: Ladda.create(document.querySelector('.edit-profile-bottom')),

    initialize: function(options) {
        options = options || {};
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.listenTo(this.model, 'change', this.setSaveButtonState);
        this.listenTo(this.model, 'change:photoUrl', this.renderPhoto);
        this.listenTo(this.model, 'validated', this.setSaveButtonState);
        this.render();
        this.hasChanged = false;
        var thisView = this;
        $(window).bind('beforeunload', function() {
            if (thisView.hasChanged) {
                return 'You have unsaved data.';
            }
        });

        new EditProfileImageView({
            model: this.model,
            imageProperty: 'photoUrl',
            parentView: this,
            el: this.$('.profile-img')
        });

        this.linkedInProfileView = new LinkedInProfileView({
            model: this.model,
            el: this.$('.js-linkedin-profile-view')
        });
        this.linkedInProfileView.render();
    },

    formChanged: function() {
        this.hasChanged = true;
    },

    renderSelectElements: function() {
        this.$('[name="country"]').val(this.model.get('country'));
    },

    linkedInErrorLogic: function(error) {
        Global.get('me').unset('linkedInId');
        const message = error && error.message;
        if (message) {
            this.$('.edit-profile-alert').text('message');
        } else {
            this.$('.edit-profile-alert').text('Error connecting with Linkedin');
            var TokenMismatchError = 4031;
            if (error == TokenMismatchError) {
                this.$('.edit-profile-alert').text('Linkedin account binded to another user');
            }
        }
        this.$('#sync-linkedin-alert').hide();
        this.$('.edit-profile-saved').toggleClass('edit-profile-saved-error', true);
        this.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-error-bottom', true);
        setTimeout(function() {
            this.$('.edit-profile-saved').toggleClass('edit-profile-saved-error', false);
            this.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-error-bottom', false);
        }, 2000);
    },

    syncBasicInformationFromLinkedin: function() {
        const thisView = this;
        const me = this.model;
        let auth = new Auth();
        const error = this.linkedInErrorLogic.bind(this);
        const success = (data) => {
            me.setLinkedinData(data);
            thisView.$('#sync-linkedin-alert').hide();
            thisView.hasChanged = true;
        };
        auth.connectWithLinkedin({error, success});
    },

    saveClicked: function() {
        var thisView = this;
        var success = function() {
            thisView.saveButton.stop();
            thisView.saveButtonBottom.stop();
            thisView.$('.edit-profile-saved').toggleClass('edit-profile-saved-displayed');
            thisView.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-displayed-bottom');
            thisView.$('.edit-profile-alert').text('Profile Saved!');
            setTimeout(function() {
                // toggle back after 2 seconds
                thisView.$('.edit-profile-saved').toggleClass('edit-profile-saved-displayed');
                thisView.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-displayed-bottom');
            }, 2000);
        };

        var error = function() {
            thisView.saveButton.stop();
            thisView.saveButtonBottom.stop();
            thisView.$('.edit-profile-saved').toggleClass('edit-profile-saved-error');
            thisView.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-error-bottom');
            thisView.$('.edit-profile-alert').text('Error saving profile');
            setTimeout(function() {
                thisView.$('.edit-profile-saved').toggleClass('edit-profile-saved-error');
                thisView.$('.edit-profile-saved-bottom').toggleClass('edit-profile-saved-error-bottom');
            }, 2000);
        };

        this.saveButton.start();
        this.saveButtonBottom.start();
        if (this.model.isValid(true)) {
            if (!this.model.get('summary')) {
                this.model.set('summary', '');
            }
            this.model.save(null, {
                success: success,
                error: error
            });
            this.hasChanged = false;
        }

    },

    setSaveButtonState: function(e) {
        if (!this.model.isValid()) {
            this.saveButton.disable();
            this.saveButtonBottom.disable();
        } else {
            if (!this.saveButton.isLoading()) {
                this.saveButton.enable();
                this.saveButtonBottom.enable();
            }
        }
    },

    renderPhoto: function() {
        var value = this.model.get('photoUrl');
        if (!value) {
            value = undefined;
        }
        var imageElement = this.$('[name="photoUrl"]');
        imageElement.attr('src', value);
    },

    render: function() {
        this.initValidation({
            attrs: ['firstName', 'lastName', 'primaryEmail', 'title', 'company', 'country', 'oneLiner', 'web', 'blog', 'summary'],
            tracking: false
        });
        this.renderSelectElements();
        this.renderPhoto();
        return this;
    }

});
_.extend(EditProfileView.prototype, FormViewMixin);

export default EditProfileView;


